import { BaseService } from "./BaseService";
import { IRoomCategoryService } from "./interfaces/IRoomCategoryService";
import {
  RoomCategoryFilters,
  RoomCategoryResponse,
  RoomCategory,
  CreateRoomCategoryRequest,
  UpdateRoomCategoryRequest,
  RoomCategoryFiltersSettings,
} from "@/types/roomCategory";

class RoomCategoryService extends BaseService implements IRoomCategoryService {
  private basePath = "/room-categories";

  constructor() {
    super();
  }
  getRoomCategoriesByHotel(
    hotelId: string,
    page?: number,
    limit?: number,
    filters?: RoomCategoryFilters,
  ): Promise<RoomCategoryResponse> {
    const roomsCategoriesFilter = {
      ...filters,
      page,
      limit,
    };

    return this.get<RoomCategoryResponse>(
      `/hotels/${hotelId}${this.basePath}`,
      roomsCategoriesFilter,
    );
  }

  getRoomCategoryById(id: string, hotelId: string): Promise<RoomCategory> {
    return this.get<RoomCategory>(`/hotels/${hotelId}${this.basePath}/${id}`);
  }
  createRoomCategory(data: CreateRoomCategoryRequest): Promise<RoomCategory> {
    const { hotelId, ...category } = data;

    return this.post<RoomCategory>(
      `/hotels/${hotelId}${this.basePath}`,
      category,
    );
  }
  updateRoomCategory(
    id: string,
    hotelId: string,
    data: UpdateRoomCategoryRequest,
  ): Promise<RoomCategory> {
    return this.put<RoomCategory>(
      `/hotels/${hotelId}${this.basePath}/${id}`,
      data,
    );
  }
  deleteRoomCategory(id: string, hotelId: string): Promise<void> {
    return this.delete<void>(`/hotels/${hotelId}${this.basePath}/${id}`);
  }

  getFiltersSettings(hotelId: string): Promise<RoomCategoryFiltersSettings> {
    return this.get<RoomCategoryFiltersSettings>(
      `/hotels/${hotelId}${this.basePath}/filters-settings`,
    );
  }
}

export const roomCategoryService = new RoomCategoryService();
